var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDispositivoFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2247_8936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5068 20.8867H34.771",
    stroke: "#E12FFF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0979 25.1348C24.2864 26.1323 24.7936 27.0416 25.5431 27.7262C25.6356 27.8127 25.6997 27.9251 25.7271 28.0487C25.7544 28.1723 25.7437 28.3013 25.6964 28.4187C25.649 28.5361 25.5673 28.6365 25.4618 28.7065C25.3564 28.7766 25.2322 28.8131 25.1056 28.8112H18.689C18.5624 28.8131 18.4382 28.7766 18.3328 28.7065C18.2273 28.6365 18.1456 28.5361 18.0982 28.4187C18.0509 28.3013 18.0402 28.1723 18.0675 28.0487C18.0949 27.9251 18.159 27.8127 18.2515 27.7262C19.0003 27.0413 19.5069 26.132 19.6952 25.1348",
    stroke: "#E12FFF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7347 17.834H1.98053C1.56574 17.834 1.22949 18.1702 1.22949 18.585V28.3471C1.22949 28.7619 1.56574 29.0982 1.98053 29.0982H6.7347C7.14949 29.0982 7.48574 28.7619 7.48574 28.3471V18.585C7.48574 18.1702 7.14949 17.834 6.7347 17.834Z",
    stroke: "#E12FFF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5067 25.1314H32.6446C33.2085 25.1314 33.7493 24.9074 34.1481 24.5087C34.5468 24.1099 34.7708 23.5691 34.7708 23.0052V8.02664C34.7708 7.46272 34.5468 6.9219 34.1481 6.52315C33.7493 6.12441 33.2085 5.90039 32.6446 5.90039H11.159C10.8798 5.90039 10.6034 5.9554 10.3455 6.06227C10.0876 6.16914 9.85333 6.32578 9.656 6.52324C9.45868 6.7207 9.3022 6.95511 9.1955 7.21307C9.08881 7.47103 9.03399 7.74749 9.03418 8.02664V11.7031",
    stroke: "#E12FFF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73461 29.0986H15.0019C15.4011 29.0986 15.7839 28.9401 16.0661 28.6578C16.3483 28.3756 16.5069 27.9928 16.5069 27.5936V13.2086C16.5065 12.8097 16.3478 12.4273 16.0656 12.1454C15.7834 11.8634 15.4008 11.7051 15.0019 11.7051H5.12023C4.72134 11.7051 4.33875 11.8634 4.05655 12.1454C3.77435 12.4273 3.61562 12.8097 3.61523 13.2086V17.8345",
    stroke: "#E12FFF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2247_8936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispositivoFull);
export default __webpack_public_path__ + "static/media/dispositivoFull.649882781eac0a85b09452baf4762b77.svg";
export { ForwardRef as ReactComponent };